import React from "react";
import FirebaseExportButton from "../../Utils/FirebaseExport";
import EventParticipantsTable from "../../Tables/EventParticipantsTable";
import { Typography } from "@mui/joy";

const ParticipantDetails = ({ eventName }: { eventName: string }) => {
  return (
    <div>
      {/* Added Firebase Export Button here. Can be adjusted as per UI/UX requirements @Nagare */}
      <div className="w-full flex justify-between items-center pb-4 ">
        <Typography level="h4">
          Participants Details
        </Typography>
        
      <FirebaseExportButton eventName={eventName} />
      </div>
      <div style={{ margin: 0, padding: 0, border: 0 }}>
        <EventParticipantsTable eventid={eventName} />
      </div>
    </div>
  );
};

export default ParticipantDetails;
